<template>
  <div>
    <div class="page-left" v-if="showLeftBar">
      <div class="seller-logo">商家后台</div>
      <el-menu default-active="active" class="el-menu-vertical-demo" @open="handleOpen"
               @close="handleClose" router background-color="#303954"
               text-color="#fff" active-text-color="#ffd04b">
        <el-submenu :index="'menu-'+index" v-for="(menu,index) in menuList" :key="index"
                    v-if="menu.children.length > 0 && menu.id != 35">
          <template slot="title">
            <i :class="'iconfont '+menu.menu_icon"></i>
            <span>{{ menu.menu_name }}</span>
          </template>
          <template v-if="isMobile">
            <el-menu-item :index="index+'-'+subIndex" v-for="(submenu,subIndex) in menu.children" :key="subIndex"
                          :route="{path:submenu.menu_url}"  @click="showLeftBar=false">
              {{ submenu.menu_name }}
            </el-menu-item>
          </template>
          <template v-else>
            <el-menu-item :index="index+'-'+subIndex" v-for="(submenu,subIndex) in menu.children" :key="subIndex"
                          :route="{path:submenu.menu_url}">
              {{ submenu.menu_name }}
            </el-menu-item>
          </template>

        </el-submenu>
        <el-menu-item :index="'menu-'+index" :route="{path:menu.menu_url}" v-else>
          <i :class="'iconfont '+menu.menu_icon"></i>
          <span slot="title">{{ menu.menu_name }}</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="page-right" :class="{'m-page-right':!showLeftBar}">
      <router-view @showLeftBar="getChildData"></router-view>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  name: 'index',

  data() {
    return {
      menuList: [],
      active: 0,
      showLeftBar:true,
      isMobile:false,
      menuParentId:0
    }
  },
  created() {
    this.getMenuList();
    if (window.screen.width <= 800){
      this.showLeftBar = false
      this.isMobile = true;
    }
  },
  methods: {
    getMenuList() {
      this.$http.get('/v1/menu/list', {params: {parentId: this.menuParentId, user_id: Cookies.get('user_id')}}).then((res) => {
        this.menuList = res.data
      });
    },
    handleOpen(key, keyPath) {
      this.active = key;
      //console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      //console.log(key, keyPath);
    },
    getChildData(data){
      console.log(data)
      this.showLeftBar = data;
    }
  }
}
</script>
<style scoped>

.page >>> .page-breadcrumb {
  margin: 0 0 30px 0;
}

.el-main {
  padding: 0;
}

.seller-logo {
  height: 59px;
  color: rgb(64, 158, 255);
  background: #303954;
  text-align: center;
  line-height: 60px;
  border-bottom: 1px solid #3e3e52;
  font-size: 18px;
  border-right: solid 1px #e6e6e6;
}

.el-aside {
  overflow: hidden;
}

.iconfont {
  margin: 0 5px 0 0;
}

.page-left {
  width: 160px;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.page-right {
  margin-left: 160px;

}

.el-submenu .el-menu-item {
  min-width: 160px;
}

.el-menu-vertical-demo {
  height: 100%;
}
::-webkit-scrollbar {
  width: 6px;
}
/*定义滑块颜色、内阴影及圆角*/
::-webkit-scrollbar-thumb{
  border-radius: 6px;
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  background-color: rgba(144,147,153,.3);
}
.m-page-right{
  margin: 0;
}
</style>
